module.exports = __webpack_public_path__ + "img/3-4.f63b5a23.png";